import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "type",
      description: "label类型(switch/display)",
      type: "String",
      default: "switch"
    },
    {
      prop: "theme",
      description: "label主题(switch类型有1,2,3,4；display类型有1,2)",
      type: "String",
      default: "1"
    },
    {
      prop: "size",
      description: "大小 mini/small/default/middle/large",
      type: "String",
      default: "default"
    },
    {
      prop: "disabled",
      description: "是否禁用，只对switch类型有效",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "removable",
      description: "是否显示删除按钮",
      type: "Boolean",
      default: "false"
    }
  ],
  events: [
    {
      name: "change",
      description: "值改变事件",
      argument: "value"
    }
  ],
  methods: [],
  slots: [
    {
      name: "default",
      description: "label内容"
    }
  ]
};
export default DemoPageWrapper(Demo, DemoSource, config);
